import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power4, TimelineLite, TweenLite} from "gsap";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";

/**
 * Created by h3 on 2017-10-25.
 */

export class TeslaFreeSpinOutroAnimation extends BaseView {
    private _gameWidth:number;
    private _gameHeight:number;


    private _paperAnimation:TimelineSprite;
    private _backgroundGfx:PIXI.Graphics;

    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._gameWidth = TeslaGameConfig.instance.GAME_WIDTH;
        this._gameHeight = TeslaGameConfig.instance.GAME_HEIGHT;
    }

    protected initAnimations():void {

        this._backgroundGfx = new PIXI.Graphics();
        this._backgroundGfx.beginFill(0x17172c, 1);
        this._backgroundGfx.drawRect(0, 0, TeslaGameConfig.instance.GAME_WIDTH, TeslaGameConfig.instance.GAME_HEIGHT);
        this._backgroundGfx.endFill();
        this._backgroundGfx.alpha = 0;
        this.addChild(this._backgroundGfx);

        this._paperAnimation = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.FS_PAPER_ANIMATION));
        this._paperAnimation.anchor.set(0.5, 0.5);
        this._paperAnimation.scale.set(1.5, 1.5);
        this._paperAnimation.position.set(this._gameWidth * 0.5, this._gameHeight * 0.5);
        this._paperAnimation.hide();
        this.addChild(this._paperAnimation);


    }

    public getShowAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const windowAnimation:TimelineLite = Tesla.backgroundWindowAnimation.getAnimation();


        const startFadeTime:number = tl.totalDuration();

        tl.add([
            () => this._paperAnimation.show(),
            this._paperAnimation.getAnimation()
        ], "+=0.5");


        tl.add(windowAnimation, 0);
        tl.add(new TweenLite(this._backgroundGfx, tl.totalDuration() - startFadeTime, {alpha : 0.5}), startFadeTime);


        return tl;
    }


    public getRemoveAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            new TweenLite(this._paperAnimation.position, 0.5, {ease : Power4.easeIn, y : "+=720"}),
            new TweenLite(this._backgroundGfx, 0.5, {alpha : 0})
        ]);
        tl.add(() => this.onRemoveAnimationComplete());
        return tl;
    }

    private onRemoveAnimationComplete() {
        this._paperAnimation.position.set(this._gameWidth * 0.5, this._gameHeight * 0.5);
        this._paperAnimation.hide();
        this._backgroundGfx.alpha = 0;
    }
}